"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var Spinner = _styledComponents["default"].div.withConfig({
  displayName: "Spinner",
  componentId: "sc-1w4wyuk-0"
})(["border:2px solid rgba(16,36,48,0.1);animation:spin 1s linear infinite;border-top:2px solid currentColor;border-radius:50%;margin:0 0.4rem;width:24px;height:24px;@keyframes spin{0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}}"]);
var _default = exports["default"] = Spinner;
//# sourceMappingURL=Spinner.js.map